import script from "./CupGroupTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CupGroupTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__